import withProps from 'recompose/withProps';
import { connect } from 'react-redux';
import withHandlers from 'recompose/withHandlers';
import compose from 'recompose/compose';
import DepositsReport, { DEPOSIT_REPORT_EXPORT_DAYS } from '../../main/reports/depositsReport';
import {
  getBarberDepositsReport,
  exportBarberDepositsReport,
} from '../../main/reports/actions';
import fetchData from '../../main/reports/hoc/fetchData';
import withTimezone from '../../auth/utils/withTimezone';

const mapStateToProps = state => ({
  barberUser: state.auth.barberUser,
  startDate: state.reports.startDate,
  endDate: state.reports.endDate,
});

const mapDispatchToProps = {
  getBarberDepositsReport,
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withTimezone,
  withProps({
    exportReportDays: DEPOSIT_REPORT_EXPORT_DAYS,
  }),
  withHandlers({
    getReport: props => (start, end) => props.getBarberDepositsReport(props.barberUser.id, start, end),
    getCsv: props => () => exportBarberDepositsReport(
      props.barberUser.id,
      props.startDate,
      props.endDate,
      props.timezone
    ),
  }),
  fetchData
);

export default enhance(DepositsReport);
